import React from 'react';

export default function TermsOfService() {
    return <>
        <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.</p>
        <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.</p>
        <p><i>Last updated: (Thursday, 13 February 2020)</i></p>
        <ol type="A">
            <li id="AccountTerms">Account Terms
                <p>
                    The only way to have an account on Portacode is by signing in with a verified Github account.
                    Thus, Portacode's users are bound by Github's Terms of Service too,
                    including that a human must create your Account; you must be 13 or over;
                    you must provide a valid email address.
                    You alone are responsible for your account and anything that happens while you are signed in
                    to or using your Account. You are responsible for keeping your Account secure.
                </p>
                <ol>
                    <li>Required Information:
                        <p>
                            You must share a valid email address with Portacode in order to complete the signup process.
                            Any other information requested, such as your real name, is optional,
                            unless you are accepting these terms on behalf of a legal entity
                            (in which case we need more information about the legal entity) or if you opt for a paid
                            account, in which case additional information will be necessary for billing purposes.
                        </p>
                    </li>
                    <li>User Account Security:
                        <p>
                            The content of your account and its security are up to you. We offer a strict session-handling
                            algorithm but any device having access to your Github account can directly create a login session
                            to your Portacode account. You are responsible for keeping both your Github and Portacode accounts
                            secure while you use our service.
                        </p>
                    </li>
                </ol>
            </li>
            <li id="AcceptableUse">Acceptable Use
                <p>
                    Your use of the Website and Service must not violate any applicable laws, including copyright or
                    trademark laws, export control or sanctions laws, or other laws in your jurisdiction. You are responsible
                    for making sure that your use of the Service is in compliance with laws and any applicable regulations.
                </p>
            </li>
            <li id="UserGeneratedContent">User-Generated Content
                <p>
                    You own content you create, but you allow us certain rights to it, so that we can display
                    and share the content you post. You still have control over your content, and responsibility for it, and the
                    rights you grant us are limited to those we need to provide the service.
                </p>
            </li>
            <li id="PrivateRepositories">Private Repositories
                <p>
                    You may grant Portacode access to your private repositories. We treat the content of private repositories
                    as confidential, and we only access it for support reasons, with your consent, or for security reasons if required.
                </p>
                <p>
                    <ol>Access to Private Repositories
                        <p>Portacode's employees may only access the content of your private repositories in the following situations:</p>
                        <ul>
                            <li>
                                With your consent and knowledge, for support reasons. If Portacode accesses a private
                                repository for support reasons, we will only do so with the owner’s consent and knowledge
                            </li>
                            <li>
                                When access is required for security reasons, including when access is required to maintain
                                ongoing confidentiality, integrity, availability and resilience of Portacode's systems and Service.
                            </li>
                        </ul>
                    </ol>
                </p>
                <p>
                    <ol>Confidentiality of Private Repositories
                        <p>
                            Portacode considers the contents of private repositories to be confidential to you. Portacode will
                            protect the contents of private repositories from unauthorized use, access, or disclosure in the same
                            manner that we would use to protect our own confidential information of a similar nature and in no event
                            with less than a reasonable degree of care.
                        </p>
                    </ol>
                </p>
            </li>
            <li id="IntellectualPropertyNotice">Intellectual Property Notice
                <p>
                    We own the service and all of our content. In order for you to use our content, we give you
                    certain rights to it, but you may only use our content in the way we have allowed.
                </p>
                <p>
                    We retain ownership of all intellectual property rights of any kind related to the Website
                    and Service. We reserve all rights that are not expressly granted to you under this Agreement
                    or by law. The look and feel of the Website and Service is copyright © Portacode, Inc. All rights
                    reserved. You may not duplicate, copy, or reuse any portion of the HTML/CSS, Javascript, or visual
                    design elements or concepts without express written permission from Portacode.
                </p>
            </li>
            <li id="CancellationAndTermination">Cancellation and Termination
                <p>
                    You may cancel this agreement and revoke any permissions granted to Portacode by your GitHub account at any time using the settings at <a href="https://github.com/settings/applications">https://github.com/settings/applications</a>.
                </p>
            </li>
            <li id="CommunicationsWithPortacode">Communications with Portacode
                <p>We only use email and other electronic means to stay in touch with our users. We do not provide phone support.</p>
            </li>
            <li id="DisclaimerOfWarranties">Disclaimer of Warranties
                <p>We provide our service as is, and we make no promises or guarantees about this service. </p>
            </li>
            <li id="LimitationOfLiability">Limitation of Liability
                <p>We will not be liable for damages or losses arising from your use or inability to use the service or otherwise arising under this agreement.</p>
            </li>
            <li id="Changes">Changes to our Terms
                <p>
                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material
                    we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change
                    will be determined at our sole discretion.
                </p>
            </li>
        </ol>
    </>
}